













































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';


@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',
      'documents', 'meta'
    ]),
    ...mapGetters(STORE_KEY, []),
  },
  methods: {
    ...mapActions(STORE_KEY, [])
  },
  components: {
  }
})
export default class DealCorrections extends Vue {
    @Prop() documentId!: string;

    public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`)
    }
  }

  public mounted() {
    // console.log('this.config', this.config)
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
    });
  }
}
